import { Model } from 'core/models';

export class LdapUser extends Model {
    public id?: number;
    public ldapUsername?: string;
    public key?: string;

}
